import { Component, Input } from '@angular/core';
import { ChannelStatus } from 'src/app/models/channel';
import { isPending, buildChannelStatus } from '../utility/campaign';

@Component({
    selector: 'app-channel-status-color-coding',
    templateUrl: './channel-status-color-coding.component.html',
    styleUrls: ['./channel-status-color-coding.component.scss']
})
export class ChannelStatusColorCodingComponent {
    @Input() currentChannelStatus: ChannelStatus;
    ChannelStatus = ChannelStatus;

    constructor() {}

    isPending(status) {
        return isPending(status);
    }

    buildChannelStatusToolTip(status) {
        return buildChannelStatus(status);
    }
}
